'use client';

import React, { createContext, useContext } from 'react';

interface TerritoryPanelContextType {
  expandedReps: string[];
  selectedTerritory: any;
  onToggle: (repName: string) => void;
  onSelect: (territory: any) => void;
}

const TerritoryPanelContext = createContext<TerritoryPanelContextType | null>(
  null
);

export const useTerritoryPanel = () => {
  const context = useContext(TerritoryPanelContext);
  if (!context) {
    throw new Error(
      'useTerritoryPanel must be used within a TerritoryPanelProvider'
    );
  }
  return context;
};

interface TerritoryPanelProviderProps {
  children: React.ReactNode;
  value: TerritoryPanelContextType;
}

export const TerritoryPanelProvider: React.FC<TerritoryPanelProviderProps> = ({
  children,
  value,
}) => {
  return (
    <TerritoryPanelContext.Provider value={value}>
      {children}
    </TerritoryPanelContext.Provider>
  );
};
